import React, { type ReactNode } from "react";
import { twMerge, twJoin } from "tailwind-merge";

import { SupText } from "../../../../components/UI/Text";

import SupUpArrowAlt from "../../../../icons/UpArrowAlt";
import SupDownArrowAlt from "../../../../icons/DownArrowAlt";

interface HeaderCellProps {
  title: ReactNode;
  direction?: "ASC" | "DESC";
  align?: "left" | "right" | "center";
  className?: string;
  sortable?: boolean;
}

export function HeaderCell({ className, title, direction, align = "left", sortable }: HeaderCellProps) {
  const controlClassName = twJoin(
    "shrink-0 transition-opacity",
    direction ? "w-auto block opacity-100" : "w-0 hidden opacity-0 group-hover/head-cell:w-auto group-hover/head-cell:block group-hover/head-cell:opacity-44"
  );

  return (
    <div className={twMerge("flex gap-2 items-center max-w-full text-neutral-900", align === "right" ? "flex-row-reverse" : "flex-row", className)}>
      <div className="flex min-w-0">
        {typeof title === "string" ? (
          <SupText as="div" variant="subtitle1" className="whitespace-nowrap text-ellipsis overflow-hidden">
            {title}
          </SupText>
        ) : (
          title
        )}
      </div>
      {sortable && (direction === "DESC" ? <SupDownArrowAlt className={controlClassName} /> : <SupUpArrowAlt className={controlClassName} />)}
    </div>
  );
}
